import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/** Applies ?search= from URL once on mount, then removes it from the address bar. */
export function useUrlSearchQuery(setSearchQuery: (query: string) => void) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const query = searchParams.get('search')?.trim();
    if (!query) return;

    setSearchQuery(query);
    const next = new URLSearchParams(searchParams);
    next.delete('search');
    setSearchParams(next, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
